import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, withText } from 'preact-i18n';

import localUtil from '../../lib/util';

@withText(props => ({
    selectEmployee: <Text id='dyrejournal.select-employee'>Select Employee</Text>,
    noEmployees: <Text id='dyrejournal.no-employees'>No employees found</Text>,
    cancel: <Text id='dyrejournal.cancel'>Cancel</Text>,
    currentEmployee: <Text id='dyrejournal.current-employee'>Current Employee</Text>,
    selectToSave: <Text id='dyrejournal.select-to-save'>Select an employee to continue saving the sale</Text>,
    lastSelected: <Text id='dyrejournal.last-selected'>Last Selected</Text>,
}))
@observer
class EmployeePicker extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onClickSelectEmployee = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { id } = e.target.closest('.employee-item').dataset;
        const { callback, onSelect } = this.props;

        const employeeId = parseInt(id, 10);

        // Validate employeeId before proceeding
        if (!employeeId || isNaN(employeeId)) {
            console.error('Invalid employeeId selected:', id);
            return;
        }

        // Save selected employee to localStorage for future sales
        localStorage.setItem('dyrejournal_lastSelectedSalesPerson', employeeId);

        // Call the onSelect callback with the selected employee ID
        if (onSelect) {
            await onSelect(employeeId);
        }

        // Close drawer first
        this.onClickCancel();

        // Then call callback to continue with save
        if (callback) {
            callback(employeeId);
        }
    }

    onClickCancel = () => {
        const { appState } = this.props.stores;
        const { drawerLevel = 1, onCancel } = this.props;
        appState.toggleDrawer(false, drawerLevel);
        if (onCancel) {
            onCancel();
        }
    }

    componentDidMount() {
        // Employees are already loaded in saleStore.employees
    }

    render() {
        const {
            selectEmployee,
            noEmployees,
            cancel,
            currentEmployee,
            selectToSave,
            lastSelected,
        } = this.props;
        const { userStore, saleStore } = this.props.stores;
        const { user } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const { currentUserId, lastSelectedEmployee } = this.props;
        const { employees = [] } = saleStore;

        return (
            <div class='w-100 d-flex flex-column' style='min-height: 100%;'>
                <div class='font-weight-lighter px-3 py-3 box-header d-flex flex-row justify-content-between'>
                    <h5>
                        <i class='fa-solid fa-user-check me-2'></i>
                        {selectEmployee}
                    </h5>
                </div>

                <div class={`mx-3 mb-3 px-3 py-2 rounded ${darkmode ? 'bg-secondary' : 'bg-light'}`}>
                    <small class='text-muted'>{selectToSave}</small>
                </div>

                {currentUserId && (
                    <div class={`mx-3 mb-3 px-3 py-2 rounded ${darkmode ? 'bg-secondary' : 'bg-light'}`}>
                        <small class='text-muted'>{currentEmployee}:</small>
                        <div class='font-weight-bold'>
                            {(() => {
                                const emp = employees.find(e => e.id === currentUserId);
                                return emp ? `${emp.firstname || ''} ${emp.lastname || ''}`.trim() || `ID: ${currentUserId}` : `ID: ${currentUserId}`;
                            })()}
                        </div>
                    </div>
                )}

                <div class='flex-fill overflow-auto mx-3 mt-2' style='max-height: calc(100vh - 300px);'>
                    {employees && employees.length > 0 ? (
                        <div class='d-flex flex-column'>
                            {employees.map((emp, idx) => {
                                const image = localUtil.getImage({ user: emp });
                                const isCurrentEmployee = emp.id === currentUserId;
                                const isLastSelected = emp.id === lastSelectedEmployee && !isCurrentEmployee;
                                return (
                                    <div
                                        key={emp.id}
                                        class={`employee-item d-flex flex-row align-items-center py-2 px-3 mb-1 rounded ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} ${isCurrentEmployee ? 'border border-primary' : ''} ${isLastSelected ? 'border border-success' : ''}`}
                                        style='cursor: pointer;'
                                        data-id={emp.id}
                                        onClick={this.onClickSelectEmployee}
                                    >
                                        <div
                                            class={`${darkmode ? 'bg-secondary' : 'bg-light'} rounded-circle d-flex justify-content-center align-items-center me-3`}
                                            style={`width: 40px; height: 40px; ${image ? `background-image: url('${image}'); background-size: cover;` : ''}`}
                                        >
                                            {!image && (
                                                <span class='font-weight-lighter'>
                                                    {emp.firstname ? emp.firstname[0] : '?'}
                                                </span>
                                            )}
                                        </div>
                                        <div class='flex-fill'>
                                            <div class='font-weight-bold'>
                                                {emp.firstname} {emp.lastname}
                                                {isCurrentEmployee && (
                                                    <span class='badge bg-primary ms-2'>
                                                        <Text id='dyrejournal.current'>Current</Text>
                                                    </span>
                                                )}
                                                {isLastSelected && (
                                                    <span class='badge bg-success ms-2'>
                                                        {lastSelected}
                                                    </span>
                                                )}
                                            </div>
                                            <small class='text-muted'>
                                                {emp.email && <span>{emp.email}</span>}
                                            </small>
                                        </div>
                                        <div>
                                            <i class='fa-solid fa-chevron-right text-muted'></i>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div class='text-center text-muted py-4'>
                            <i class='fa-solid fa-user-slash fa-2x mb-2'></i>
                            <div>{noEmployees}</div>
                        </div>
                    )}
                </div>

                <div class='d-flex flex-row justify-content-end mx-3 my-3'>
                    <button
                        type='button'
                        class='btn btn-outline-secondary rounded-pill'
                        onClick={this.onClickCancel}
                    >
                        <i class='fa-solid fa-times me-2'></i>
                        {cancel}
                    </button>
                </div>
            </div>
        );
    }
}

export default EmployeePicker;
